import React from 'react';
import { ErrorMessage, Grid, Header1Text, Pager } from 'ui-toolkit';
import { IVendorOrdersData } from '../../../types/vendorDashboard/IVendorOrders';
import { ISearchOrdersSettingsData } from '../../../types/vendorDashboard/ISearchOrdersSettingsData';
import {
  allVendorStatuses,
  eTitleSearchStatus,
  vendorInitialStatuses,
} from '../../../types/order/title/eTitleSearchStatus';
import { VendorOrdersFilter } from '../../../components/vendorDashboard/VendorOrdersFilter';
import { VendorDashTabs } from '../../../components/vendorDashboard/VendorDashTabs';
import { OrderSearchForm } from '../../../components/vendorDashboard/comments/OrderSearchForm';
import { OrdersTable } from '../../../components/vendorDashboard/OrdersTable';
import { ISearchOrdersSpecificationData } from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';

export interface IVendorOrdersPageProps {
  pageError?: string;
  orders: IVendorOrdersData;
  searchSettings: ISearchOrdersSettingsData;
  loadingOrder: boolean;
  onFilterOrder: (status: eTitleSearchStatus[]) => void;
  onPageSizeUpdate: (pageSize: number) => void;
  onPageUpdate: (page: number) => void;
  onSearchOrder: (value: ISearchOrdersSpecificationData) => void;
}

export const VendorOrdersPage: React.FC<IVendorOrdersPageProps> = ({
  pageError,
  orders,
  searchSettings,
  loadingOrder,
  onFilterOrder,
  onPageSizeUpdate,
  onPageUpdate,
  onSearchOrder,
}) => {
  return (
    <>
      <ErrorMessage message={pageError} />
      <VendorDashTabs
        activeTabIndex={0}
        prefix={<Header1Text>Orders</Header1Text>}
        suffix={
          <VendorOrdersFilter
            onFilterPayoff={onFilterOrder}
            statuses={searchSettings.statuses}
            defaultStatuses={vendorInitialStatuses}
            filterOptions={allVendorStatuses}
          />
        }
      >
        <Grid>
          <OrderSearchForm onSearchOrder={onSearchOrder} />
          <OrdersTable orders={orders.titleSearches} loading={loadingOrder} />
          <Pager
            onPageSizeChange={onPageSizeUpdate}
            onPageChange={onPageUpdate}
            pageSize={searchSettings.pageSize}
            page={searchSettings.page}
            total={orders.total}
            disabled={loadingOrder}
          />
        </Grid>
      </VendorDashTabs>
    </>
  );
};
